export const PROBLEM_BASE_URL = 'http://www.jhipster.tech/problem';
export const EMAIL_ALREADY_USED_TYPE = PROBLEM_BASE_URL + '/email-already-used';
export const LOGIN_ALREADY_USED_TYPE = PROBLEM_BASE_URL + '/login-already-used';
export const EMAIL_NOT_FOUND_TYPE = PROBLEM_BASE_URL + '/email-not-found';

export const REQUIRED_FIELD = 'Required field';
export const SELECT_A_VALUE = 'Please select an option';
export const Date_NOT_SELECTED = 'Please select a date';
export const STARTDT_GT_ENDDT = 'Start date should not be greater than End date';
export const FROMDT_GT_TODT = 'From date should not be greater than To date';
export const REPSTDT_GT_REPENDDT = 'Report Period End date should not be greater than Report Period Begin date';
export const REPSTDT_GTR_REPENDDT = 'Report Period Start date should not be greater than Report Period End date';
export const REPENDDT_LT_REPSTDT = 'Report Period End date should not be less than Report Period Start date';

export const REPSTDT_INTERVAL_REPENDDT = 'Report Period End date and Report Period Begin date interval should be within 1 year';
export const REPSTDT_INTERVAL_REPENDDT_3M = 'Report Period End date and Report Period Begin date interval should be within 3 months maximun';

export const INVALID_EMAIL = 'Invalid email.';
export const USER_EXIST = 'User Already Exist.';

export const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REPMIAGE_GT_REPMAAGE = 'Report Minimum Age should not be greater than Report Maximum Age';
export const REPMIAGE_EQ_REPMAAGE = 'Report Minimum Age should not be equal to Report Maximum Age';


// WEBPACK FOOTER //
// ./src/app/shared/constants/error.constants.ts